export enum ProjectExecutionTypes {
  BID,
  EXECUTING_AGENCY,
}
